import script from "./SvgLogo.vue?vue&type=script&setup=true&lang=ts"
export * from "./SvgLogo.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__